import React, { useState, useEffect } from "react";
import { NepaliDatePicker } from "datepicker-nepali-reactjs";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import UseInput from "../UseInput"
import FileUpload from "../FileUpload"
import "react-toastify/dist/ReactToastify.css";
import Comments from "./Comments";
import './style.css';
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
// import { useSelector } from 'react-redux';
import store from '../../store';

export default function ViewModal({
  remarks
}) {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const state = store.getState();
  
  return  (
  <div className="comment-box view-file has-file" onClick={toggle}>
      <i class="fa fa-eye"  aria-hidden="true"></i>
      <Modal
        returnFocusAfterClose={false}
        isOpen={modal}
        toggle={toggle}
        className={"modal-xl modal-dialog-centered comments-wrap"}
      >
        <ModalHeader toggle={toggle}>फाइल हेर्नुहोस् </ModalHeader>
        <ModalBody>
        <div className="manual-wrapper">
            <iframe src={remarks}></iframe>
          </div>
        </ModalBody>
    </Modal>
    </div>
  )
}
